import Map from './map';
import CustomMarkerClass from './custom-marker-class';

type DataToCreate = {
  div: HTMLDivElement;
  map: Map;
}

type DataToInitialize = {
  div: HTMLDivElement;
  map: Map;
  coordinates: google.maps.LatLng;
}

abstract class AbstractMarker {

  readonly div: HTMLDivElement;
  readonly map: Map;
  readonly coordinates: google.maps.LatLng;
  readonly google: google.maps.OverlayView;

  protected constructor(data: DataToInitialize) {
    this.div = data.div;
    this.map = data.map;
    this.coordinates = data.coordinates;
    this.google = this.getGoogleObject();
  }

  private getGoogleObject(): google.maps.OverlayView {
    const options = {
      map: this.map.google,
      position: this.coordinates,
    };
    return new (CustomMarkerClass.create())(this.div, options);
  };

}

export default AbstractMarker;
export { DataToCreate };
